import React, { useEffect, useRef } from "react";
import "./Banner.css";
import TShirtFront from '../../../assets/images/PersonalizedGifts/BannerImg.jpg';
import TShirtBack from '../../../assets/images/PersonalizedGifts/Banner.jpg';


const Banner = () => {
  const bannerRef = useRef(null);
  const crackersContainerRef = useRef(null);

  useEffect(() => {
    const bannerElement = bannerRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            bannerElement.classList.add("animate");
          } else {
            bannerElement.classList.remove("animate");
          }
        });
      },
      { threshold: 0.5 }
    );

    if (bannerElement) {
      observer.observe(bannerElement);
    }

    return () => {
      if (bannerElement) {
        observer.unobserve(bannerElement);
      }
    };
  }, []);

  const handleMouseEnter = () => {
    const crackersContainer = crackersContainerRef.current;

    const colors = ["#f5d061", "#f28e8e", "#8ec1f2", "#8ef2a7", "#f2e08e", "#e68ef2", "red", "brown"];

    if (crackersContainer) {
      crackersContainer.innerHTML = '';
      for (let i = 0; i < 30; i++) {
        const cracker = document.createElement("div");
        cracker.className = "cracker";
        cracker.style.left = `${Math.random() * 100}%`;
        cracker.style.animationDelay = `${Math.random() * 2}s`;
        cracker.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        crackersContainer.appendChild(cracker);
      }
    }
  };

  return (
    <>
      <div className="banner-container" ref={bannerRef}>
        <div className="banner-content">
          <div className="image-container">
            <img
              src={TShirtFront}
              alt="Baby Clothing"
              className="baby-image first-image"
            />
            <img
              src={TShirtBack}
              alt="Baby Clothing"
              className="baby-image second-image"
            />
          </div>
          <div className="text-container">
            <h1 className="banner-title">Personalize your favourites</h1>
            <p className="banner-subtitle">Best for gifting</p>
            <p className="banner-categories">Kids | Adults</p>
            <button
              className="shop-now-btn"
              onMouseEnter={handleMouseEnter}
            >
              Shop Now
            </button>
          </div>
        </div>
        <div className="crackers-container" ref={crackersContainerRef}></div>
      </div>
    </>
  );
};

export default Banner;
